/* eslint-disable nordic/no-img-tags */
/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable max-len */
const React = require('react');
const Message = require('@andes/message');
const { Image } = require('nordic/image');
const SnippetContainer = require('../APIReference/SnippetContainer');
const SectionHeader = require('./components/SectionHeader');
const PostmanBanner = require('./components/PostmanBanner');
const FeedbackThumbs = require('../FeedbackThumbs');
const { useApiRefContextProvider } = require('../../../providers/apiRefContextProvider');

const APIReferenceHome = ({ assetsPath, deviceType, brand }) => {
  const { lang, i18n, platform } = useApiRefContextProvider();
  const imagePath = `${assetsPath}images/home/${deviceType === 'mobile' ? 'mobile' : 'desktop'}`;
  const apiExampleImageVersion = brand === 'yellowblue-light' ? 'v4' : 'v3';
  const apiExampleImage = `${imagePath}/api-ref-home-example-${lang}-${apiExampleImageVersion}.png`;

  const notADeveloperMessage = (
    <Message
      className="header-warning"
      color="accent"
      hierarchy="quiet"
      title={i18n.gettext('¿No eres desarrollador?')}
    >
      <div>
        {i18n.gettext('Usa nuestras')}
        <a href={`/developers/${lang}/docs#platform-list`}> {i18n.gettext('soluciones de e-commerce listas')} </a>
        {i18n.gettext('para usar en diferentes plataformas')}.
      </div>
    </Message>
  );

  return (
    <div className="reference-wrapper">
      <div className="layout-main">
        <div className="api-reference-home">
          <div className="api-reference-home--header">
            <div className="header-content">
              <SectionHeader
                title={i18n.gettext('Mercado Pago API')}
                messages={[
                  `${i18n.gettext('La API de Mercado Pago te permite interactuar de forma directa con toda la información que necesitas para desarrollar tus integraciones como quieras.')}`,
                  <>
                    {i18n.gettext('Para realizar solicitudes, tienes que autenticar cada pedido con las credenciales de tu aplicación. Si aún no tienes una, consulta los pasos básicos para comenzar a implementar nuestras soluciones.')}
                  </>,
                ]}
              />
            </div>

            <div className="header-code">
              <SnippetContainer
                title={i18n.gettext('Base URL')}
                i18n={i18n}
                codeContent="https://api.mercadopago.com"
                codeLanguage="bash"
                type="response"
                lang={lang}
                copyTrakingData={{
                  category: 'MPDEVELOPERS',
                  action: 'HOME_COPY_ENDPOINT',
                  label: 'Copy base endpoint at home\'s page',
                }}
              />
            </div>
            {(deviceType === 'mobile') && (
              notADeveloperMessage
            )}
          </div>

          <div className="divider" />

          <div className="api-reference-home--middle">
            <div className="title">
              <SectionHeader title={i18n.gettext('Autenticación')} />
            </div>

            <div className="body">
              <div className="body--left">
                <p className="message">
                  {`${i18n.gettext('Para conectar las integraciones y tu cuenta de una manera segura, tienes que realizar todas las solicitudes a nuestra API utilizando HTTPS e incluir las credenciales de tu aplicación para autenticar cada interacción')}.`}
                  <br />
                  {`${i18n.gettext('Las llamadas realizadas a través de HTTP simple y sin autenticación, fallarán')}.`}
                </p>
                <Message
                  className="header-warning"
                  color="orange"
                  hierarchy="quiet"
                  title={i18n.gettext('Importante')}
                >
                  <div>{`${i18n.gettext('Nunca expongas tu clave privada en un repositorio público, ni la utilices en tu código client-side. Siempre hazlo de manera segura desde tu servidor')}.`}</div>
                </Message>
              </div>

              <div className="body--right">
                <p className="message">
                  {`${i18n.gettext('Configura el Access Token en el header Authorization de todas las solicitudes como muestra el siguiente ejemplo')}.`}
                </p>
                <SnippetContainer
                  title={i18n.gettext('cURL ejemplo')}
                  i18n={i18n}
                  codeContent={`curl -H ‘Authorization: Bearer <ENV_ACCESS_TOKEN>’  \\
                    https://api.mercadopago.com/V1/payments`}
                  codeLanguage="bash"
                  type="response"
                  lang={lang}
                  copyTrakingData={{
                    category: 'MPDEVELOPERS',
                    action: 'HOME_COPY_ENDPOINT',
                    label: 'Copy base endpoint at home\'s page',
                  }}
                />
              </div>
            </div>
          </div>

          <div className="divider" />
          <PostmanBanner deviceType={deviceType} />
          <div className="divider" />

          <div className="api-reference-home--examples">
            <SectionHeader
              title={i18n.gettext('Explora la API')}
              messages={[
                `${i18n.gettext('Encuentra en cada secciones todo lo que necesitas saber para realizar el pedido de información que quieras')}.`,
              ]}
            />

            <div className="image-container">
              <Image
                alt="ejemplo"
                className="image"
                src={apiExampleImage}
              />
            </div>
          </div>
        </div>
      </div>
      {(deviceType === 'mobile') && (
        <div className="api-reference-home__feedback-mobile">
          <FeedbackThumbs
            lang={lang}
            siteId={platform.siteId}
          />
        </div>
      )}
      {(deviceType !== 'mobile') && (
        <div className="right-sidebar-reference-home">
          <div className="header-image">
            <div style={{ marginBottom: 24 }}>
              <FeedbackThumbs
                lang={lang}
                siteId={platform.siteId}
              />
            </div>
            {notADeveloperMessage}
          </div>
        </div>
      )}
    </div>
  );
};

module.exports = APIReferenceHome;
